module.exports = __webpack_public_path__ + "static/img/242x340.b71d6ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/242x340.png
// module id = JdFK
// module chunks = 8